__turbopack_context__.v({
  "popupClose": "styles-module-scss-module__FsW7ia__popupClose",
  "popupContent": "styles-module-scss-module__FsW7ia__popupContent",
  "popupHeader": "styles-module-scss-module__FsW7ia__popupHeader",
  "popupHeaderWithLogo": "styles-module-scss-module__FsW7ia__popupHeaderWithLogo",
  "popupModal": "styles-module-scss-module__FsW7ia__popupModal",
});
